import { Layout } from "components/structure-components/layout"
import { Link } from "gatsby"
import React from "react"
import { SEOComponent } from "components/seo-components"
import { updateCookieSettings } from "components/utils"

const DatenschutzerklaerungPage = ({ location }) => {
  const breadcrumb_array = [
    {
      type: "BreadcrumbLink",
      content: "bau.bi",
      link: `/`,
      react_key: "footer_breadcrumb_item_0",
      ressort: "mitternachtsblau",
    },
    {
      type: "BreadcrumbSpan",
      content: "Datenschutzerklärung",
      link: ``,
      react_key: "footer_breadcrumb_item_4",
      ressort: "mitternachtsblau",
    },
  ]
  return (
    <Layout {...{ location, breadcrumb_array }}>
      <SEOComponent
        title="Datenschutzerklärung"
        description="Datenschutzerklärung der B_I MEDIEN GmbH, Anbieter der B_I ausschreibungsdienste, B_I eVergabe und Verleger der B_I fachzeitschriften."
      />
      <div className="columns is-centered">
        <div className="column is-6">
          <div className="section">
            <h1 className="title is-2 mt-4 mb-5">
              Datenschutzerklärung der B_I MEDIEN GmbH
            </h1>

            <div className="content">
              <h2 className="title is-3">Einführung und Geltungsbereich</h2>
              <p>
                Die Webanwendungen B_I ausschreibungsdatenbank und B_I eVergabe,
                die Fachzeitschriften B_I baumagazin, B_I galabau, B_I umweltbau
                und B_I baufahrzeuge sowie die Webauftritte bau.bi,
                bi-medien.de, nodig-bau.de, nodig-construction.com,
                trenchless-guide.com, branchenfuehrer-galabau.de und
                branchenfuehrer-leitungsbau.de sind Angebote der B_I MEDIEN
                GmbH. Diese Datenschutzerklärung klärt Nutzer über die Art, den
                Umfang und Zwecke der Erhebung und Verwendung personenbezogener
                Daten durch den verantwortlichen Anbieter B_I MEDIEN GmbH auf.
              </p>
              <h2 className="title is-3">
                Name und Anschrift des Verantwortlichen
              </h2>
              <p>
                Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und
                anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie
                sonstiger datenschutzrechtlicher Bestimmungen ist die:
                <br />
                B_I MEDIEN GmbH
                <br />
                Faluner Weg 33
                <br />
                24109 Kiel
                <br />
                Deutschland
                <br />
                Tel.: +49 (431) 53592-0
                <br />
                E-Mail: info@bi-medien.de
                <br />
                Website: https://bi-medien.de
              </p>
              <h2 className="title is-3">
                Name und Anschrift des Datenschutzbeauftragten
              </h2>
              <p>
                Der Datenschutzbeauftragte des Verantwortlichen ist:
                <br />
                Kevin Ebsen
                <br />
                Faluner Weg 33
                <br />
                24109 Kiel
                <br />
                Deutschland
                <br />
                Tel.: +49 (431) 53592-0
                <br />
                E-Mail: datenschutz@bi-medien.de
                <br />
              </p>
              <h2 className="title is-3">Allgemeines zur Datenverarbeitung</h2>
              Wir verarbeiten personenbezogene Daten unserer Nutzer
              grundsätzlich nur, soweit dies zur Bereitstellung einer
              funktionsfähigen Website sowie unserer Inhalte und Leistungen
              erforderlich ist. Die Verarbeitung personenbezogener Daten unserer
              Nutzer erfolgt regelmäßig nur nach Einwilligung des Nutzers. Eine
              Ausnahme gilt in solchen Fällen, in denen eine vorherige Einholung
              einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und
              die Verarbeitung der Daten durch gesetzliche Vorschriften
              gestattet ist.
              <br />
              Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine
              Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1
              lit. a EU-Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage.
              Bei der Verarbeitung von personenbezogenen Daten, die zur
              Erfüllung eines Vertrages, dessen Vertragspartei die betroffene
              Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als
              Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur
              Durchführung vorvertraglicher Maßnahmen erforderlich sind. Soweit
              eine Verarbeitung personenbezogener Daten zur Erfüllung einer
              rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen
              unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.
              Ist die Verarbeitung zur Wahrung eines berechtigten Interesses
              unseres Unternehmens oder eines Dritten erforderlich und
              überwiegen die Interessen, Grundrechte und Grundfreiheiten des
              Betroffenen das erstgenannte Interesse nicht, so dient Art. 6 Abs.
              1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.
              <br />
              Die personenbezogenen Daten der betroffenen Person werden gelöscht
              oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine
              Speicherung kann darüber hinaus erfolgen, wenn dies durch den
              europäischen oder nationalen Gesetzgeber in unionsrechtlichen
              Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der
              Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder
              Löschung der Daten erfolgt auch dann, wenn eine durch die
              genannten Normen vorgeschriebene Speicherfrist abläuft, es sei
              denn, dass eine Erforderlichkeit zur weiteren Speicherung der
              Daten für einen Vertragsabschluss oder eine Vertragserfüllung
              besteht.
              <br />
              <h2 className="title is-3">
                Bereitstellung der Website und Erstellung von Logfiles
              </h2>
              <div>
                <b>Beschreibung und Umfang der Datenverarbeitung</b>
                <br />
                Bei jedem Aufruf unserer Internetseite erfasst unser System
                automatisiert Daten und Informationen vom Computersystem des
                aufrufenden Rechners. Folgende Daten werden hierbei erhoben:
                <dl className="has-margin-left-20">
                  <li>
                    Informationen über den Browsertyp und die verwendete Version
                  </li>
                  <li>Das Betriebssystem des Nutzers</li>
                  <li>Den Internet-Service-Provider des Nutzers</li>
                  <li>Die IP-Adresse des Nutzers</li>
                  <li>Datum und Uhrzeit des Zugriffs</li>
                </dl>
                Websites, von denen das System des Nutzers auf unsere
                Internetseite gelangt Websites, die vom System des Nutzers über
                unsere Website aufgerufen werden Die Daten werden ebenfalls in
                den Logfiles unseres Systems gespeichert. Eine Speicherung
                dieser Daten zusammen mit anderen personenbezogenen Daten des
                Nutzers findet nicht statt.
                <br />
                Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit
                der Website sicherzustellen. Zudem dienen uns die Daten zur
                Optimierung der Website und zur Sicherstellung der Sicherheit
                unserer informationstechnischen Systeme. Eine Auswertung der
                Daten zu Marketingzwecken findet in diesem Zusammenhang nicht
                statt.
                <br />
                In diesen Zwecken liegt auch unser berechtigtes Interesse an der
                Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO.
                <br />
                Daten in Logfiles werden nach spätestens sieben Tagen gelöscht.
                Eine darüberhinausgehende Speicherung ist möglich. In diesem
                Fall werden die IP-Adressen der Nutzer gelöscht oder verfremdet,
                sodass eine Zuordnung des aufrufenden Clients nicht mehr möglich
                ist.
                <br />
                Die Erfassung der Daten zur Bereitstellung der Website und die
                Speicherung der Daten in Logfiles ist für den Betrieb der
                Internetseite zwingend erforderlich. Es besteht folglich seitens
                des Nutzers keine Widerspruchsmöglichkeit.
                <br />
              </div>
              <h2 className="title is-3">
                Newsletter und Mailversand durch externe Dienstleister
              </h2>
              <div>
                Auf unserer Internetseite besteht die Möglichkeit einen
                kostenfreien Newsletter zu abonnieren oder auch an
                themenspezifischen Wissenstests und E-Mail-Kursen teilzunehmen.
                Dabei werden bei der Anmeldung die Daten aus der Eingabemaske an
                uns übermittelt, hierbei handelt es sich um die E-Mail-Adresse
                und Namen des Nutzers sowie ggf. angegebene Interessen.
                <br />
                Zudem werden folgende Daten bei der Anmeldung erhoben:
                <br />
                <dl className="has-margin-left-20">
                  <li> Datum und Uhrzeit der Registrierung,</li>
                </dl>
                Für die Verarbeitung der Daten wird im Rahmen des
                Anmeldevorgangs Ihre Einwilligung eingeholt und auf diese
                Datenschutzerklärung verwiesen.
                <br />
                Weiterhin arbeiten wir im Rahmen des Mailversands mit Sendinblue
                (Sendinblue GmbH, Köpenicker Str. 126, 10179 Berlin ) zusammen.
                Auch hier erfolgt die Datenverarbeitung nur nach vorheriger
                Zustimmung des Nutzers. Nähere Informationen zu den
                entsprechenden Datenschutzbestimmungen finden Sie unter
                <a href="https://de.sendinblue.com/legal/privacypolicy/">
                  {" "}
                  https://de.sendinblue.com/legal/privacypolicy/
                </a>
                <br />
                Das Abonnement des Newsletters, der Wissenstests und der
                E-Mail-Kursen kann durch den betroffenen Nutzer jederzeit
                gekündigt werden. Zu diesem Zweck findet sich in jeder Mail ein
                entsprechender Link.
                <br />
              </div>
              <h2 className="title is-3">Registrierung</h2>
              <div>
                Auf unserer Internetseite bieten wir Nutzern die Möglichkeit,
                sich unter Angabe personenbezogener Daten zu registrieren. Die
                Daten werden dabei in eine Eingabemaske eingegeben und an uns
                übermittelt und gespeichert. Eine Weitergabe der Daten an Dritte
                findet nicht statt. Folgende Daten werden im Rahmen des
                Registrierungsprozesses erhoben:
                <br />
                <dl className="has-margin-left-20">
                  <li>Name und Anschrift des Unternehmens</li>
                  <li>Name des Ansprechpartners</li>
                  <li>Telefonnummer und E-Mail-Adresse des Nutzers</li>
                </dl>
                Im Zeitpunkt der Registrierung werden zudem folgende Daten
                gespeichert:
                <br />
                <dl className="has-margin-left-20">
                  <li>Datum und Uhrzeit der Registrierung</li>
                </dl>
                Im Rahmen des Registrierungsprozesses wird eine Einwilligung des
                Nutzers zur Verarbeitung dieser Daten eingeholt.
                <br />
                Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen
                einer Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO sowie
                zusätzlich Art. 6 Abs. 1 lit. b DSGVO.
                <br />
                Die Registrierung des Nutzers ist zur Erfüllung eines Vertrages
                mit dem Nutzer oder zur Durchführung vorvertraglicher Maßnahmen
                erforderlich.
                <br />
                Die Daten werden gelöscht, sobald sie für die Erreichung des
                Zwecks ihrer Erhebung nicht mehr erforderlich sind. Dies ist für
                die während des Registrierungsvorgangs zur Erfüllung eines
                Vertrags oder zur Durchführung vorvertraglicher Maßnahmen dann
                der Fall, wenn die Daten für die Durchführung des Vertrages
                nicht mehr erforderlich sind. Auch nach Abschluss des Vertrags
                kann jedoch eine Erforderlichkeit, personenbezogene Daten des
                Vertragspartners zu speichern, bestehen, um vertraglichen oder
                gesetzlichen Verpflichtungen nachzukommen. Eine vorzeitige
                Löschung der Daten ist nur möglich, soweit nicht vertragliche
                oder gesetzliche Verpflichtungen einer Löschung entgegenstehen.
                Gespeicherte Daten können Sie jederzeit ändern lassen.
                <br />
              </div>
              <h2 className="title is-3">Kontaktformular und E-Mail-Kontakt</h2>
              <div>
                Auf unserer Internetseite ist ein Kontaktformular vorhanden,
                welches für die elektronische Kontaktaufnahme genutzt werden
                kann. Nimmt ein Nutzer diese Möglichkeit wahr, so werden die in
                der Eingabemaske eingegeben Daten an uns übermittelt und
                gespeichert. Diese Daten sind:
                <dl className="has-margin-left-20">
                  <li>Name</li>
                  <li>Telefonnummer</li>
                  <li>Bemerkungen des Nutzers.</li>
                </dl>
                Im Zeitpunkt der Absendung der Nachricht werden zudem folgende
                Daten gespeichert:
                <dl className="has-margin-left-20">
                  <li>Datum und Uhrzeit der Registrierung</li>
                </dl>
                Für die Verarbeitung der Daten wird im Rahmen des
                Absendevorgangs Ihre Einwilligung eingeholt und auf diese
                Datenschutzerklärung verwiesen. Alternativ ist eine
                Kontaktaufnahme über die bereitgestellte E-Mail-Adresse möglich.
                In diesem Fall werden die mit der E-Mail übermittelten
                personenbezogenen Daten des Nutzers gespeichert.
                <br />
                Die Daten werden ausschließlich für die Verarbeitung der
                Konversation verwendet.
                <br />
                Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen
                einer Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO.
                Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge
                einer Übersendung einer E-Mail übermittelt werden, ist Art. 6
                Abs. 1 lit. f DSGVO. Zielt der E-Mail-Kontakt auf den Abschluss
                eines Vertrages ab, so ist zusätzliche Rechtsgrundlage für die
                Verarbeitung Art. 6 Abs. 1 lit. b DSGVO.
                <br />
                Die Verarbeitung der personenbezogenen Daten aus der
                Eingabemaske dient uns allein zur Bearbeitung der
                Kontaktaufnahme. Im Falle einer Kontaktaufnahme per E-Mail liegt
                hieran auch das erforderliche berechtigte Interesse an der
                Verarbeitung der Daten.
                <br />
                Die sonstigen während des Absendevorgangs verarbeiteten
                personenbezogenen Daten dienen dazu, einen Missbrauch des
                Kontaktformulars zu verhindern und die Sicherheit unserer
                informationstechnischen Systeme sicherzustellen.
                <br />
                Die Daten werden gelöscht, sobald sie für die Erreichung des
                Zweckes ihrer Erhebung nicht mehr erforderlich sind. Für die
                personenbezogenen Daten aus der Eingabemaske des
                Kontaktformulars und diejenigen, die per E-Mail übersandt
                wurden, ist dies dann der Fall, wenn die jeweilige Konversation
                mit dem Nutzer beendet ist. Beendet ist die Konversation dann,
                wenn sich aus den Umständen entnehmen lässt, dass der betroffene
                Sachverhalt abschließend geklärt ist.
                <br />
                Der Nutzer hat jederzeit die Möglichkeit, seine Einwilligung zur
                Verarbeitung der personenbezogenen Daten zu widerrufen. Nimmt
                der Nutzer per E-Mail Kontakt mit uns auf, so kann er der
                Speicherung seiner personenbezogenen Daten jederzeit
                widersprechen. In einem solchen Fall kann die Konversation nicht
                fortgeführt werden. Alle personenbezogenen Daten, die im Zuge
                der Kontaktaufnahme gespeichert wurden, werden in diesem Fall
                gelöscht.
                <br />
              </div>
              <h2 className="title is-3">Groove Support</h2>
              <div>
                Auf unserer Website gibt es die Möglichkeit die
                Kundensupporttools von GrooveHQ zu nutzen. Dabei handelt es sich
                um eine Wissensdatenbank, um geläufige Fragen zu beantworten.
                Hierbei wird Ihre IP-Adresse gespeichert. Durch die Auswahl
                einer Antwortmöglichkeit werden Sie auf das Helpcenter unserer
                Website weitergeleitet.
                <br />
                Weiterhin können Sie im Rahmen dieser Nutzung spezifische Fragen
                an unseren Kundensupport richten, indem Sie eine Nachricht
                hinterlassen. Dabei werden folgende personenbezogene Daten
                gespeichert.
                <dl className="has-margin-left-20">
                  <li>IP-Adresse</li>
                  <li>Browserart</li>
                  <li>Artikel, von dem die Anfrage gestellt wurde</li>
                  <li>Name (sofern angegeben)</li>
                  <li>E-Mail-Adresse</li>
                  <li>Datum und Uhrzeit</li>
                </dl>
                Hierbei wird zunächst Ihre Einwilligung eingeholt und auf diese
                Datenschutzerklärung verwiesen. Die entsprechende
                Rechtsgrundlage ist demnach Art. 6 Abs. 1 lit. a DSGVO. Die
                Daten werden ausschließlich zur Beantwortung Ihrer Fragen
                verwendet.
                <br />
                Die Daten werden hierbei ebenfalls bei Groove Networks LLC
                gespeichert (2 Dearborn Street, Newport, Rhode Island 02840,
                USA). Weitere Information zum Umgang mit personenbezogenen Daten
                durch GrooveHQ finden Sie unter{" "}
                <a href={"https://www.groovehq.com/our/privacy"}>
                  https://www.groovehq.com/our/privacy
                </a>
                .
              </div>
              <h2 className="title is-3">
                Weitergabe an Vergabestellen und Bestellung von
                Vergabeunterlagen
              </h2>
              <p>
                Sofern Sie sich an einem Vergabeverfahren beteiligen und über
                den B_I bieterassistenten ein Angebot abgeben, geben wir
                ausschließlich die für das Vergabeverfahren notwendigen Daten an
                die Vergabestelle weiter.
                <br />
                Weiterhin werden bei der Bestellung von Vergabeunterlagen, Ihr
                Name sowie Ihre Anschrift an die Deutsche Post weitergeleitet,
                damit die Zustellung erfolgen kann. Außerdem wird Ihre Firma auf
                der Bieterliste vermerkt, die an die Vergabestelle übermittelt
                wird.
                <br />
              </p>
              <h2 className="title is-3">Google Analytics</h2>
              <p>
                Zur Optimierung unserer Website, und damit aufgrund eines
                berechtigten Interesses gemäß Art. 6 Abs.1 S.1 lit. f, nutzen
                wir Google Analytics. Dabei werden sog. „Cookies“ auf Ihrem
                Computer gespeichert, wodurch eine Analyse unserer Website
                ermöglicht wird. Hierbei werden Daten an Google gesandt, wobei
                die IP-Adressen durch die Verwendung einer Anonymisierung
                (anonymizeIp) gekürzt werden, somit ist keine exakte
                Lokalisierung Ihres Computers möglich. Die im Rahmen von Google
                Analytics von Ihrem Browser übermittelte IP-Adresse wird ferner
                nicht mit anderen Daten von Google zusammengeführt. Sofern Sie
                die Verwendung von Google Analytics unterbinden wollen, können
                Sie über
                <a
                  href={"https://tools.google.com/dlpage/gaoptout?hl=de?hl=de"}
                >
                  https://tools.google.com/dlpage/gaoptout?hl=de?hl=de
                </a>{" "}
                ein sog. „Opt-Out-Cookie“ setzen. Wir weisen Sie jedoch darauf
                hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche
                Funktionen dieser Website vollumfänglich nutzen können werden.
                <br />
                Nähere Informationen zu Nutzungsbedingungen und Datenschutz
                finden Sie unter: <br />
                <a href={"https://www.google.com/analytics/terms/de.html"}>
                  https://www.google.com/analytics/terms/de.html
                </a>{" "}
                bzw. unter: <br />
                <a href={"https://www.google.de/intl/de/policies/"}>
                  https://www.google.de/intl/de/policies/
                </a>
                .
              </p>
              <h2 className="title is-3">Google Adwords Conversion Tracking</h2>
              <p>
                Diese Website nutzt ferner das Google Conversion Tracking. Dabei
                wird von Google Adwords ein Cookie auf Ihrem Rechner gesetzt,
                sofern Sie über eine Google-Anzeige auf unsere Website gelangt
                sind. Diese Cookies verlieren nach 30 Tagen ihre Gültigkeit und
                dienen nicht der persönlichen Identifizierung. Besucht der
                Nutzer bestimmte Seiten der Website des Adwords-Kunden und das
                Cookie ist noch nicht abgelaufen, können Google und der Kunde
                erkennen, dass der Nutzer auf die Anzeige geklickt hat und zu
                dieser Seite weitergeleitet wurde. Jeder Adwords-Kunde erhält
                ein anderes Cookie. Cookies können somit nicht über die Websites
                von Adwords-Kunden nachverfolgt werden. Die mithilfe des
                Conversion-Cookies eingeholten Informationen dienen dazu,
                Conversion-Statistiken für Adwords-Kunden zu erstellen, die sich
                für Conversion-Tracking entschieden haben. Die Adwords-Kunden
                erfahren die Gesamtanzahl der Nutzer, die auf ihre Anzeige
                geklickt haben und zu einer mit einem Conversion-Tracking-Tag
                versehenen Seite weitergeleitet wurden. Sie erhalten jedoch
                keine Informationen, mit denen sich Nutzer persönlich
                identifizieren lassen. Wenn Sie nicht an dem Tracking-Verfahren
                teilnehmen möchten, können Sie auch das hierfür erforderliche
                Setzen eines Cookies ablehnen – etwa per Browser-Einstellung,
                die das automatische Setzen von Cookies generell deaktiviert.
                Sie können Cookies für Conversion-Tracking auch deaktivieren,
                indem Sie Ihren Browser so einstellen, dass Cookies von der
                Domain „www.googleadservices.com“ blockiert werden. Nähere
                Informationen zu Nutzungsbedingungen und Datenschutz finden Sie
                unter: <br />
                <a href="https://www.google.de/intl/de/policies/">
                  https://www.google.de/intl/de/policies/
                </a>
              </p>
              <h2 className="title is-3">Google Forms</h2>
              <p>
                Wir nutzen Google Forms, um unregelmäßig anonymisierte Nutzer-
                und Kundenumfragen durchzuführen. Die Auswertung dient
                ausschließlich der redaktionellen und vertrieblichen Optimierung
                unserer Produkte. Hierbei werden die anonymisierten Antworten
                verarbeitet. Die standardmäßige Erfassung der E-Mail-Adresse von
                Google Forms ist deaktiviert. Zur technischen Abwicklung werden
                während der Sitzung die IP-Adresse, Datum und Uhrzeit des
                Zugriffs sowie andere Geräteinformationen wie z.B. Browsertyp
                und -version oder das Betriebssystem von Google Forms
                verarbeitet. Diese technisch notwendigen Daten werden nicht zur
                Auswertung verwendet und können auch nicht mit den Antworten in
                Verbindung gebracht werden. Die Verarbeitung erfolgt auf
                Grundlage unseres überwiegenden berechtigten Interesses (Art. 6
                Abs. 1 lit. f DSGVO) an der Marktforschung.
                <br />
                Google Forms ist ein Dienst von Google Ireland Limited, Gordon
                House, Barrow Street, Dublin 4, Irland. Weitere Informationen
                zum Umgang mit personenbezogenen Daten finden Sie unter:{" "}
                <a href="https://policies.google.com/privacy">
                  https://policies.google.com/privacy
                </a>.
              </p>
              <h2 className="title is-3">Zahlungsabwicklung</h2>
              <p>
                Zur Zahlungsabwicklung von Vertragsverhältnissen per PayPal,
                giropay und Kreditkarte nutzen wir die Dienste der BS PAYONE
                GmbH, Lyoner Straße 9, 60528 Frankfurt/Main. Grundlage für die
                Weitergabe von Kundendaten ist hierbei Art. 6 Abs. 1 S.1 lit. b
                DSGVO. Die Zahlungsabwicklung folgt den höchsten
                Sicherheitsanforderungen. Sämtliche Datenübermittlung erfolgt
                bis zu 256 Bit SSL verschlüsselt und ist dadurch vor dem
                unbefugten Zugriff durch Dritte geschützt. Darüber hinaus werden
                Kreditkartendaten nach den strengsten Sicherheitsauflagen der
                Kreditkartenindustrie, dem sogenannten Payment Card Industry
                Data Security Standard (kurz PCI DSS), seitens des
                zertifizierten Payment Service Providers PAYONE GmbH erarbeitet
                und gespeichert. Personen- wie auch kartenbezogene Daten sind
                somit nach dem höchsten Sicherheitsstandard auch im Sinne des
                Datenschutzes geschützt. Weitere Datenschutzbestimmungen sind
                unter{" "}
                <a href="https://www.payone.com/datenschutz/">
                  https://www.payone.com/datenschutz/
                </a>{" "}
                zu finden.
              </p>
              <h2 className="title is-3">Online-Werbung</h2>
              <p>
                B_I MEDIEN arbeitet mit der Aumago GmbH („Aumago“), Berlin,
                einem ZielgruppenVermarkter zusammen. Aumago verwendet
                sogenannte Cookies, eine Textdatei, die im Browser des Computers
                gespeichert wird. Es werden pseudonyme Nutzungsdaten in Form von
                Cookie IDs und Werbe IDs ohne IP Adressen im Cookie erhoben. Die
                Cookie ID und Werbe IDs ohne IP Adresse reichen nicht aus, um
                eine natürliche Person hinter einem Browser / Nutzer zu
                identifizieren. Aumago vermutet auf Grundlage des Surfverhaltens
                (besuchte Website, Kategorien, Produktseiten) des Nutzers ein
                Interesse für eine spezifische B2B Branche und verwendet im
                Auftrag der B_I MEDIEN GmbH diese Information, um gezieltere,
                nutzungsbasierte OnlineWerbung auszusteuern. Die Cookies können
                diesbezüglich über ein sogenanntes Cookie Matching mit anderen
                Plattformen synchronisiert werden. Das Matching kann z.B.
                stattfinden für: Google, Doubleclick, Adition, Appnexus,
                Mediamath, The Trade Desk, Adform, Active Agent, yieldlab. Bei
                den Cookies handelt es sich entweder um Aumago Cookies oder
                Cookies von Dienstleistern, derer sich Aumago bedient wie z.B.
                der The ADEX GmbH, Berlin. Der Nutzer kann jederzeit über
                folgenden Link (
                <a href="https://dmp.theadex.com/donttrack/1?rdr=http://www.theadex.com/opt-out">
                  https://dmp.theadex.com/donttrack/1?rdr=http://www.theadex.com/opt-out
                </a>
                ) sein Opt-out und damit Widerspruch zum diesbezüglichen Cookie
                Tracking erklären. Dadurch wird ein sogenanntes Opt-out Cookie
                gesetzt. Das OptOut Cookie setzt voraus, dass eine Einstellung
                im Browser nicht die Speicherung von Cookies verhindert oder den
                Cookie löscht. Nach einer Löschung des Opt-out Cookies muss der
                Nutzer den Widerspruch wiederholen. Alternativ kann der Nutzer
                die Cookies direkt im Browser löschen, von Anfang an seien
                Browser-Einstellungen auf Do-not-track setzen oder seine
                Cookie-Präferenzen hier: <br />
                <a href="http://www.youronlinechoices.com/de/praferenzmanagement/">
                  http://www.youronlinechoices.com/de/praferenzmanagement/
                </a>
                <br />
                verwalten. Sollten Sie eine Auskunft über die in Ihrem Cookie
                gespeicherten Informationen erhalten wollen, senden uns bitte
                Ihre Cookie ID.“
              </p>
              <button
                className="button is-mitternachtsblau is-fullwidth-mobile"
                onClick={function () {
                  // The cookie solution uses a callback when the settings widget is closed ('OnBannerClosed') which triggers
                  // the event "cookie_update_force_refresh".
                  // Page reload may be necessary in case cookie permissions have been withdrawn for certain purposes to
                  // ensure now (after withdrawl) cookie-setting services are no longer active.
                  document.addEventListener(
                    "cookie_update_force_refresh",
                    function () {
                      document.location.reload()
                    }
                  )
                  window._iub.cs.ui.showCP(!1, !0)
                }}
              >
                Cookie-Einstellung anpassen
                {/* Ihre Cookie-Einstellungen für Werbung auf dieser Seite anpassen */}
              </button>
              <h2 className="title is-3">Rechte der betroffenen Person</h2>
              <p>
                Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie
                Betroffener i.S.d. DSGVO und es stehen Ihnen folgende Rechte
                gegenüber dem Verantwortlichen zu:
              </p>
              <h3 className="title is-4">Auskunftsrecht</h3>
              <div>
                Sie können von dem Verantwortlichen eine Bestätigung darüber
                verlangen, ob personenbezogene Daten, die Sie betreffen, von uns
                verarbeitet werden. Liegt eine solche Verarbeitung vor, können
                Sie von dem Verantwortlichen über folgende Informationen
                Auskunft verlangen:
                <ol type="1">
                  <li>
                    die Zwecke, zu denen die personenbezogenen Daten verarbeitet
                    werden;
                  </li>
                  <li>
                    die Kategorien von personenbezogenen Daten, welche
                    verarbeitet werden;
                  </li>
                  <li>
                    die Empfänger bzw. die Kategorien von Empfängern, gegenüber
                    denen die Sie betreffenden personenbezogenen Daten
                    offengelegt wurden oder noch offengelegt werden;
                  </li>
                  <li>
                    die geplante Dauer der Speicherung der Sie betreffenden
                    personenbezogenen Daten oder, falls konkrete Angaben hierzu
                    nicht möglich sind, Kriterien für die Festlegung der
                    Speicherdauer;
                  </li>
                  <li>
                    das Bestehen eines Rechts auf Berichtigung oder Löschung der
                    Sie betreffenden personenbezogenen Daten, eines Rechts auf
                    Einschränkung der Verarbeitung durch den Verantwortlichen
                    oder eines Widerspruchsrechts gegen diese Verarbeitung;
                  </li>
                  <li>
                    das Bestehen eines Beschwerderechts bei einer
                    Aufsichtsbehörde;
                  </li>
                  <li>
                    alle verfügbaren Informationen über die Herkunft der Daten,
                    wenn die personenbezogenen Daten nicht bei der betroffenen
                    Person erhoben werden;
                  </li>
                </ol>
                Ihnen steht das Recht zu, Auskunft darüber zu verlangen, ob die
                Sie betreffenden personenbezogenen Daten in ein Drittland oder
                an eine internationale Organisation übermittelt werden. In
                diesem Zusammenhang können Sie verlangen, über die geeigneten
                Garantien gem. Art. 46 DSGVO im Zusammenhang mit der
                Übermittlung unterrichtet zu werden.
              </div>
              <h3 className="title is-4">Recht auf Berichtigung</h3>
              <div>
                Sie haben ein Recht auf Berichtigung und/oder Vervollständigung
                gegenüber dem Verantwortlichen, sofern die verarbeiteten
                personenbezogenen Daten, die Sie betreffen, unrichtig oder
                unvollständig sind. Der Verantwortliche hat die Berichtigung
                unverzüglich vorzunehmen. Recht auf Einschränkung der
                Verarbeitung Unter den folgenden Voraussetzungen können Sie die
                Einschränkung der Verarbeitung der Sie betreffenden
                personenbezogenen Daten verlangen:
                <ol type="1">
                  <li>
                    wenn Sie die Richtigkeit der Sie betreffenden
                    personenbezogenen für eine Dauer bestreiten, die es dem
                    Verantwortlichen ermöglicht, die Richtigkeit der
                    personenbezogenen Daten zu überprüfen;
                  </li>
                  <li>
                    die Verarbeitung unrechtmäßig ist und Sie die Löschung der
                    personenbezogenen Daten ablehnen und stattdessen die
                    Einschränkung der Nutzung der personenbezogenen Daten
                    verlangen;
                  </li>
                  <li>
                    der Verantwortliche die personenbezogenen Daten für die
                    Zwecke der Verarbeitung nicht länger benötigt, Sie diese
                    jedoch zur Geltendmachung, Ausübung oder Verteidigung von
                    Rechtsansprüchen benötigen, oder
                  </li>
                  <li>
                    wenn Sie Widerspruch gegen die Verarbeitung gemäß Art. 21
                    Abs. 1 DSGVO eingelegt haben und noch nicht feststeht, ob
                    die berechtigten Gründe des Verantwortlichen gegenüber Ihren
                    Gründen überwiegen.
                  </li>
                </ol>
                Wurde die Verarbeitung der Sie betreffenden personenbezogenen
                Daten eingeschränkt, dürfen diese Daten – von ihrer Speicherung
                abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung,
                Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz
                der Rechte einer anderen natürlichen oder juristischen Person
                oder aus Gründen eines wichtigen öffentlichen Interesses der
                Union oder eines Mitgliedstaats verarbeitet werden. Wurde die
                Einschränkung der Verarbeitung nach den o.g. Voraussetzungen
                eingeschränkt, werden Sie von dem Verantwortlichen unterrichtet
                bevor die Einschränkung aufgehoben wird.
              </div>
              <h3 className="title is-4">Recht auf Löschung</h3>
              <div>
                <b>a) Löschungspflicht</b>
                <br />
                Sie können von dem Verantwortlichen verlangen, dass die Sie
                betreffenden personenbezogenen Daten unverzüglich gelöscht
                werden, und der Verantwortliche ist verpflichtet, diese Daten
                unverzüglich zu löschen, sofern einer der folgenden Gründe
                zutrifft:
                <ol type="1">
                  <li>
                    Die Sie betreffenden personenbezogenen Daten sind für die
                    Zwecke, für die sie erhoben oder auf sonstige Weise
                    verarbeitet wurden, nicht mehr notwendig.
                  </li>
                  <li>
                    Sie widerrufen Ihre Einwilligung, auf die sich die
                    Verarbeitung gem. Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2
                    lit. a DSGVO stützte, und es fehlt an einer anderweitigen
                    Rechtsgrundlage für die Verarbeitung.
                  </li>
                  <li>
                    Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die
                    Verarbeitung ein und es liegen keine vorrangigen
                    berechtigten Gründe für die Verarbeitung vor, oder Sie legen
                    gem. Art. 21 Abs. 2 DSGVO Widerspruch gegen die Verarbeitung
                    ein.
                  </li>
                  <li>
                    Die Sie betreffenden personenbezogenen Daten wurden
                    unrechtmäßig verarbeitet.
                  </li>
                  <li>
                    {" "}
                    Die Löschung der Sie betreffenden personenbezogenen Daten
                    ist zur Erfüllung einer rechtlichen Verpflichtung nach dem
                    Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich,
                    dem der Verantwortliche unterliegt.
                  </li>
                  <li>
                    Die Sie betreffenden personenbezogenen Daten wurden in Bezug
                    auf angebotene Dienste der Informationsgesellschaft gemäß
                    Art. 8 Abs. 1 DSGVO erhoben.
                  </li>
                </ol>
                <b>b) Information an Dritte</b>
                <br />
                Hat der Verantwortliche die Sie betreffenden personenbezogenen
                Daten öffentlich gemacht und ist er gem. Art. 17 Abs. 1 DSGVO zu
                deren Löschung verpflichtet, so trifft er unter Berücksichtigung
                der verfügbaren Technologie und der Implementierungskosten
                angemessene Maßnahmen, auch technischer Art, um für die
                Datenverarbeitung Verantwortliche, die die personenbezogenen
                Daten verarbeiten, darüber zu informieren, dass Sie als
                betroffene Person von ihnen die Löschung aller Links zu diesen
                personenbezogenen Daten oder von Kopien oder Replikationen
                dieser personenbezogenen Daten verlangt haben.
                <br />
                <b>c) Ausnahmen</b>
                <br />
                Das Recht auf Löschung besteht nicht, soweit die Verarbeitung
                erforderlich ist zur Geltendmachung, Ausübung oder Verteidigung
                von Rechtsansprüchen.
              </div>
              <h3 className="title is-4">Recht auf Unterrichtung</h3>
              <p>
                Haben Sie das Recht auf Berichtigung, Löschung oder
                Einschränkung der Verarbeitung gegenüber dem Verantwortlichen
                geltend gemacht, ist dieser verpflichtet, allen Empfängern,
                denen die Sie betreffenden personenbezogenen Daten offengelegt
                wurden, diese Berichtigung oder Löschung der Daten oder
                Einschränkung der Verarbeitung mitzuteilen, es sei denn, dies
                erweist sich als unmöglich oder ist mit einem
                unverhältnismäßigen Aufwand verbunden. Ihnen steht gegenüber dem
                Verantwortlichen das Recht zu, über diese Empfänger unterrichtet
                zu werden.
              </p>
              <h3 className="title is-4">Recht auf Datenübertragbarkeit</h3>
              <p>
                Sie haben das Recht, die Sie betreffenden personenbezogenen
                Daten, die Sie dem Verantwortlichen bereitgestellt haben, in
                einem strukturierten, gängigen und maschinenlesbaren Format zu
                erhalten. Außerdem haben Sie das Recht diese Daten einem anderen
                Verantwortlichen ohne Behinderung durch den Verantwortlichen,
                dem die personenbezogenen Daten bereitgestellt wurden, zu
                übermitteln, sofern (1) die Verarbeitung auf einer Einwilligung
                gem. Art. 6 Abs. 1 lit. a DSGVO oder Art. 9 Abs. 2 lit. a DSGVO
                oder auf einem Vertrag gem. Art. 6 Abs. 1 lit. b DSGVO beruht
                und (2) die Verarbeitung mithilfe automatisierter Verfahren
                erfolgt. In Ausübung dieses Rechts haben Sie ferner das Recht,
                zu erwirken, dass die Sie betreffenden personenbezogenen Daten
                direkt von einem Verantwortlichen einem anderen Verantwortlichen
                übermittelt werden, soweit dies technisch machbar ist.
                Freiheiten und Rechte anderer Personen dürfen hierdurch nicht
                beeinträchtigt werden. Das Recht auf Datenübertragbarkeit gilt
                nicht für eine Verarbeitung personenbezogener Daten, die für die
                Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen
                Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt,
                die dem Verantwortlichen übertragen wurde.
              </p>
              <h3 className="title is-4">Widerspruchsrecht</h3>
              <p>
                Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen
                Situation ergeben, jederzeit gegen die Verarbeitung der Sie
                betreffenden personenbezogenen Daten, die aufgrund von Art. 6
                Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies
                gilt auch für ein auf diese Bestimmungen gestütztes Profiling.
                Der Verantwortliche verarbeitet die Sie betreffenden
                personenbezogenen Daten nicht mehr, es sei denn, er kann
                zwingende schutzwürdige Gründe für die Verarbeitung nachweisen,
                die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die
                Verarbeitung dient der Geltendmachung, Ausübung oder
                Verteidigung von Rechtsansprüchen. Werden die Sie betreffenden
                personenbezogenen Daten verarbeitet, um Direktwerbung zu
                betreiben, haben Sie das Recht, jederzeit Widerspruch gegen die
                Verarbeitung der Sie betreffenden personenbezogenen Daten zum
                Zwecke derartiger Werbung einzulegen; dies gilt auch für das
                Profiling, soweit es mit solcher Direktwerbung in Verbindung
                steht. Widersprechen Sie der Verarbeitung für Zwecke der
                Direktwerbung, so werden die Sie betreffenden personenbezogenen
                Daten nicht mehr für diese Zwecke verarbeitet. Sie haben die
                Möglichkeit, im Zusammenhang mit der Nutzung von Diensten der
                Informationsgesellschaft – ungeachtet der Richtlinie 2002/58/EG
                – Ihr Widerspruchsrecht mittels automatisierter Verfahren
                auszuüben, bei denen technische Spezifikationen verwendet
                werden.
              </p>
              <h3 className="title is-4">
                Recht auf Widerruf der datenschutzrechtlichen
                Einwilligungserklärung
              </h3>
              <p>
                Sie haben das Recht, Ihre datenschutzrechtliche
                Einwilligungserklärung jederzeit zu widerrufen. Durch den
                Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund
                der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht
                berührt.
              </p>
              <h3 className="title is-4">
                Automatisierte Entscheidung im Einzelfall einschließlich
                Profiling
              </h3>
              <p>
                Sie haben das Recht, nicht einer ausschließlich auf einer
                automatisierten Verarbeitung – einschließlich Profiling –
                beruhenden Entscheidung unterworfen zu werden, die Ihnen
                gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher
                Weise erheblich beeinträchtigt. Dies gilt nicht, wenn die
                Entscheidung (1) für den Abschluss oder die Erfüllung eines
                Vertrags zwischen Ihnen und dem Verantwortlichen erforderlich
                ist, (2) aufgrund von Rechtsvorschriften der Union oder der
                Mitgliedstaaten, denen der Verantwortliche unterliegt, zulässig
                ist und diese Rechtsvorschriften angemessene Maßnahmen zur
                Wahrung Ihrer Rechte und Freiheiten sowie Ihrer berechtigten
                Interessen enthalten oder (3) mit Ihrer ausdrücklichen
                Einwilligung erfolgt. Allerdings dürfen diese Entscheidungen
                nicht auf besonderen Kategorien personenbezogener Daten nach
                Art. 9 Abs. 1 DSGVO beruhen, sofern nicht Art. 9 Abs. 2 lit. a
                oder g DSGVO gilt und angemessene Maßnahmen zum Schutz der
                Rechte und Freiheiten sowie Ihrer berechtigten Interessen
                getroffen wurden. Hinsichtlich der in (1) und (3) genannten
                Fälle trifft der Verantwortliche angemessene Maßnahmen, um die
                Rechte und Freiheiten sowie Ihre berechtigten Interessen zu
                wahren, wozu mindestens das Recht auf Erwirkung des Eingreifens
                einer Person seitens des Verantwortlichen, auf Darlegung des
                eigenen Standpunkts und auf Anfechtung der Entscheidung gehört.
              </p>
              <h3 className="title is-4">
                Recht auf Beschwerde bei einer Aufsichtsbehörde
              </h3>
              <p>
                Unbeschadet eines anderweitigen verwaltungsrechtlichen oder
                gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde
                bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat
                ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des
                mutmaßlichen Verstoßes, zu, wenn Sie der Ansicht sind, dass die
                Verarbeitung der Sie betreffenden personenbezogenen Daten gegen
                die DSGVO verstößt. Die Aufsichtsbehörde, bei der die Beschwerde
                eingereicht wurde, unterrichtet den Beschwerdeführer über den
                Stand und die Ergebnisse der Beschwerde einschließlich der
                Möglichkeit eines gerichtlichen Rechtsbehelfs nach Art. 78
                DSGVO.
              </p>
              <h2 className="title is-4">Verwendung von Cookies</h2>
              <p>
                Diese Website verwendet Cookies und andere Identifikatoren.
                Weitere Informationen ergeben sich aus der{" "}
                <Link to="/cookie-richtlinie">Cookie-Richtlinie</Link>.
              </p>
              <button
                className="button is-mitternachtsblau is-fullwidth-mobile"
                onClick={updateCookieSettings}
              >
                Cookie-Einstellungen anpassen
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default DatenschutzerklaerungPage
